import { useEffect, useRef } from 'react';

export const useHandleClickOutside = <T>(callback: () => void): React.RefObject<T> => {
	const ref = useRef<T>(null);

	useEffect(() => {
		const handleClick = (event: MouseEvent): void => {
			if (ref.current && !(ref.current as any)?.contains(event.target as Node)) {
				callback();
			}
		};
		document.addEventListener('click', handleClick);

		return () => {
			document.removeEventListener('click', handleClick);
		};
	}, []);

	return ref;
};
